<template>
  <div
    class="event-card"
    :id="event.id"
    :style="{
      width: event.duration * columnWidth + unityColumnWidth,
      backgroundColor: event.color,
    }"
    @dragstart="emitDrag($event)"
    @mouseup="showEvent($event, event)"
  >
    <div class="iconsOptions">
      <div class="options">
        <span v-if="event.eventSiblings.length > 0">
          <v-icon
            :title="$t('intInformation.siblings')"
            class="iconCell"
            :style="{ fontSize: '23px' }"
            >mdi-numeric-{{
              event.eventSiblings.filter((e) => e.validated === true).length +
              1
            }}-box
          </v-icon>
          <v-icon
            v-if="
              event.eventSiblings.filter((e) => e.validated === false).length >
              0
            "
            :title="$t('intInformation.siblings')"
            class="optionIconCell"
            :style="{ fontSize: '23px' }"
            >mdi-numeric-{{
              event.eventSiblings.filter((e) => e.validated === false).length
            }}-box
          </v-icon>
        </span>

        <span v-if="event.details.type === 'TP'">
          <img
            :title="$t('enumIntStatus.professionalTitle')"
            src="@/assets/images/icons/tp_icon.png"
            class="v-icon iconCell"
            :draggable="false"
          />
        </span>

        <!-- <span v-if="event.details.type === 'POE'"> -->
        <span v-if="event.details.type === 'POE'">
          <img
            :title="$t('enumIntStatus.eop')"
            src="@/assets/images/icons/poe_icon.png"
            class="v-icon iconCell"
            :draggable="false"
          />
        </span>
      </div>

      <div
        class="redDot"
        v-if="event.details.comment"
        :title="event.details.comment"
      ></div>
    </div>

    <p :title="event.course" v-bind:style="getGridStyleColors(event)">
      {{ event.course }}
    </p>
    <div
      v-if="resizable"
      @mousedown.capture="initResize($event)"
      class="resizer"
    ></div>
  </div>
</template>

<script>
export default {
  props: ["event", "resizable", "columnWidth", "unityColumnWidth"],

  methods: {
    getGridStyleColors(event) {
      let color = {
        background: event.color,
        color: "#ffffff",
        fontWeight: "bold",
      };
      if (event.details.validated == false) {
        color.background = "#FFFFCC";
        color.color = event.color;
      }

      if (event.details.type === "INTRA") {
        color.background = "#ffd320";
        color.color = event.color;
      }
      if (
        event.details.eventSiblings.find(
          (e) => e.validated == true && e.isMaster == false
        )
      ) {
        color.background = event.details.eventSiblings.find(
          (e) => e.validated == true && e.isMaster == false
        ).location.color;
        color.color = "#ffffff";
        if (
          event.details.eventSiblings.find(
            (e) => e.validated == true && e.location.color != "#990099"
          )
        ) {
          color.background = event.details.eventSiblings.find(
            (e) => e.validated == true && e.location.color != "#990099"
          ).location.color;
          color.color = "#ffffff";
        }
      }

      // if (event.validated) {
      //   color.background = event.color;
      //   color.color = "#ffffff";
      // }
      // else

      return color;
    },
    emitDrag(e) {
      this.$emit("start-drag", e, this.event);
    },
    initResize(e) {
      this.$emit("init-resize", e);
    },
    showEvent(e, event) {
      this.$emit("show-event", event);
    },
    deleteEvent(event) {
      this.$emit("delete-event", event);
    },
  },
};
</script>

<style lang="scss">
.event-card {
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  height: var(--row-height);
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

.event-card .resizer {
  position: absolute;
  cursor: w-resize;
  position: absolute;
  right: 0;
  top: 5px;
  height: 2rem;
  width: 20px;
}

.event-card:hover .resizer {
  position: absolute;
  /* background-color: #005d44; */
  cursor: w-resize;
  border-right: rgb(34, 34, 34) 2px solid;
  margin: 3px;
}

.event-card p {
  width: 100%;
  height: 100%;
  padding: 1.5rem 0 0 5px;
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
  /* text-align: center; */
  color: rgb(36, 36, 36);
}

.event-card .v-btn {
  position: absolute;
  right: 20px;
  top: 5px;
}

.event-card .iconsOptions {
  position: absolute;
  display: grid;
  grid-template-columns: repeat(3, 3, 1fr);
  grid-column-gap: 0.1rem;
  justify-content: center;
  align-items: center;
  padding-left: 0.2rem;

  .iconCell {
    font-size: 1.1rem;
    color: rgb(36, 36, 36);
  }

  .optionIconCell {
    font-size: 1.1rem;
    color: #ffffcc;
  }

  .redDot {
    background: rgb(255, 69, 69);
    height: 8px;
    width: 8px;
    border-radius: 5px;
    cursor: help;
  }

  .options {
    cursor: help;
  }
}

.drop-preview {
  height: var(--row-height);
  background-color: rgba(180, 180, 180, 0.658);
}
</style>
